export default __webpack_public_path__ + "static/media/343.ffb2b0d6.svg";